/** Strips non-letter characters (keeps Spanish accented letters + spaces), caps at 15 chars. */
export const sanitizeNameInput = (value: string): string =>
  value.replace(/[^a-zA-ZáéíóúüñÁÉÍÓÚÜÑ\s]/g, '').slice(0, 15);
